import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import CoffeeRegularAi from './coffee-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <CoffeeRegularAi {...validProps} />;
}
SvgComponent.iconName = 'coffeeRegularAi';

export const CoffeeRegularAiIcon = svgIconWrapper(SvgComponent);
